import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslate } from '../../../components/TranslationText';
import EahsForm from '../../../components/EahsForm';
import { FormCheckbox } from '../../../components/FormInputs';

/**
 * Contract acceptance section for semen checkout.
 *
 * When a signed contract file exists (edit mode), shows a checkbox
 * that reveals a "View Signed Contract" download link when checked.
 * Otherwise shows the standard "Accept Contract" checkbox with a
 * "View Contract" link.
 *
 * @param {object|null} orderDetails - Order details from API
 * @param {boolean} disabled - Disable the checkbox (view-only mode)
 */
export default function SemenContractSection({ orderDetails, disabled = false }) {
    const { translate } = useTranslate();
    const { watch } = useFormContext();

    const acceptContract = watch('acceptContract');

    return (
        <EahsForm title={translate('web.contract', 'Contract')}>
            <div className="col-12">
                { (
                    <>
                        <FormCheckbox
                            name="acceptContract"
                            label={translate('web.acceptContract', 'Accept Contract')}
                            required
                            disabled={disabled}
                        />
                        {acceptContract && (
                            <a
                                href={`${orderDetails?.contractFile?.fileUrl}`}
                                target="_blank"
                                rel="noreferrer"
                                className="text-primary text-decoration-underline ms-4 d-block"
                                style={{ fontSize: '0.9em' }}
                            >
                                {translate('web.downloadContract', 'Download Contract')}
                            </a>
                        )}
                    </>
                )}
            </div>
        </EahsForm>
    );
}
